global.lines = {
    // Line handle styles
    handleSize: 8,
};
